const yup = require('yup');

const schema = yup.object().shape({
  password: yup
    .string()
    .min(6, 'Password is too short - should be 6 chars minimum.')
    .required('Password field is required'),

  passwordRepeat: yup
    .string()
    .required('Repeat password field is required')
    .oneOf([yup.ref('password'), null], 'Passwords must be the same'),
});

export default schema;
